// @flow
import env from '../../environment';
import {putCreator} from '../../http';

export const endpoints = Object.freeze({
  SAVE_ACCOUNT: `${env.baseApiUrl}/usher/user/vendor/data`,
});

export type SaveAccountRequest = {
  email?: string,
  firstName?: string,
  lastName?: string,
  password?: string,
  phone?: string,
};

export const saveAccountApi = putCreator(endpoints.SAVE_ACCOUNT);
